import React, { useState } from "react";
import ProgressBar from "./ProgressBar";

interface SelectionButtonProps {
  icon?: string | React.ReactNode;
  label: React.ReactNode;
  buttonLabel: string;
  onChange: () => void;
  onPlayPause?: () => void;
  progress?: number;
  enableChildHover?: boolean;
  disabled?: boolean;
  className?: string;
  buttonClassName?: string;
  iconClassName?: string;
  contentClassName?: string;
}

const SelectionButton = ({
  icon,
  label,
  buttonLabel,
  onChange,
  onPlayPause,
  progress,
  enableChildHover = false,
  disabled = false,
  className = "",
  buttonClassName = "",
  iconClassName = "",
  contentClassName = "",
}: SelectionButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const renderIcon = () => {
    if (!icon) return null;

    if (typeof icon === "string") {
      const altText = typeof label === "string" ? label : "";
      return (
        <img
          src={icon}
          alt={altText}
          className={`rounded-lg border-2 border-gray-200 ${iconClassName || "h-8"}`}
        />
      );
    }

    if (React.isValidElement(icon) && enableChildHover) {
      return React.cloneElement(icon, { isHovered } as any);
    }

    return <div>{icon}</div>;
  };

  return (
    <div
      className={`group relative flex min-w-0 flex-col rounded-[20px] border border-[#F0F0F0] bg-white font-mulish text-[15px] font-medium text-[#252525] transition-all duration-200 ${
        onPlayPause && !disabled
          ? "cursor-pointer hover:border-[#DCDCDC] hover:shadow-[0_8px_18px_rgba(0,0,0,0.07)]"
          : ""
      } ${disabled ? "opacity-60 pointer-events-none" : ""} ${className}`}
      onClick={disabled ? undefined : onPlayPause}
      onMouseEnter={() => !disabled && enableChildHover && setIsHovered(true)}
      onMouseLeave={() => !disabled && enableChildHover && setIsHovered(false)}
    >
      <div
        className={`flex w-full min-w-0 flex-row items-center gap-3 px-5 py-[18px] sm:gap-4 ${contentClassName}`}
      >
        <div className="shrink-0">{renderIcon()}</div>
        <div className="min-w-0 flex-1 text-left [overflow-wrap:anywhere]">
          {label}
        </div>
        <button
          type="button"
          disabled={disabled}
          className={`shrink-0 self-center font-mulish font-semibold text-lightgreen transition-all duration-200 hover:text-[#018354] group-hover:translate-x-[1px] disabled:cursor-not-allowed disabled:opacity-70 ${buttonClassName}`}
          onClick={onChange}
        >
          {buttonLabel}
        </button>
      </div>
      {progress !== undefined && (
        <ProgressBar progress={progress} color="#FFD84D" height="5px" />
      )}
    </div>
  );
};

export default SelectionButton;
